import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { US, KR } from 'country-flag-icons/react/1x1'
import {
  US as USWide,
  KR as KRWide,
} from 'country-flag-icons/react/3x2'

function LocaleSelect () {
  const { i18n } = useTranslation()

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'locale-select',
  })

  const LOCALES = {
    en: {
      Flag: US,
      FlagWide: USWide,
      label: 'English',
    },
    ko: {
      Flag: KR,
      FlagWide: KRWide,
      label: '한국어',
    },
  }

  const lang = i18n.language as keyof typeof LOCALES
  const CurrentFlag = LOCALES[lang].Flag

  return (
    <>
      <IconButton
        className="!p-0 !overflow-hidden w-[2rem] h-[2rem]"
        {...bindTrigger(popupState)}
      >
        <CurrentFlag />
      </IconButton>
      <Menu
        className="mt-4"
        {...bindMenu(popupState)}
      >
        {Object.entries(LOCALES).map(([locale, { FlagWide, label }]) => (
          <MenuItem
            key={locale}
            onClick={() => i18n.changeLanguage(locale)}
            selected={locale === lang}
            className="flex gap-8"
          >
            <FlagWide
              width="2rem"
              style={{
                boxShadow: '1px 1px 1px #eae9ed',
              }}
            />
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LocaleSelect
